import { config } from '../Constants';

const urlPath = config.url.CDN_URL + '/Common/';

export const staticImages = {
    itemArrowLeft: urlPath + 'gifted__itemarrow_left_1x.png',
    itemArrowLeftSelected: urlPath + 'gifted__itemarrow_left_selected_1x.png',
    itemArrowRight: urlPath + 'gifted__itemarrow_right_1x.png',
    itemArrowRightSelected: urlPath + 'gifted__itemarrow_right_selected_1x.png',
    beginArrowLeft: urlPath + 'gifted__beginarrow_left_1x.png',
    beginArrowLeftSelected: urlPath + 'gifted__beginarrow_left_selected_1x.png',
    beginArrowRight: urlPath + 'gifted__beginarrow_right_1x.png',
    beginArrowRightSelected: urlPath + 'gifted__beginarrow_right_selected_1x.png',
    endArrowLeft: urlPath + 'gifted__endarrow_left_1x.png',
    endArrowLeftSelected: urlPath + 'gifted__endarrow_left_selected_1x.png',
    endArrowRight: urlPath + 'gifted__endarrow_right_1x.png',
    endArrowRightSelected: urlPath + 'gifted__endarrow_right_selected_1x.png',
    playButton: urlPath + 'gifted__playbutton_1x.png',
    stopHand: urlPath + 'gifted__stophand_1x.png',
    checkMark: urlPath + 'gifted__checkmark_1x.png',
    error: urlPath + 'gifted__error_1x.png',
    pause: urlPath + 'Pause-icon.png',
};

export const preloadImages = () => {
    Object.values(staticImages).forEach(link => {
        const img = new Image();
        img.src = link;
    });
};